import React, { useState } from 'react';

import AddedToCartConfirmationModalContext, {
  IAddedToCartConfirmationModal,
} from '@context/Modal/added-to-cart-confirmation-modal-context';
import dynamic from 'next/dynamic';

const AddedToCartConfirmationModalNoSSR = dynamic(
  () => import(
    '@components/shared/modals/AddedToCartConfirmationModal/AddedToCartConfirmationModal'
  ),
  { ssr: false }
);

const AddedToCartConfirmationModalProvider: React.FunctionComponent = ({
  children,
}) => {
  const [modalState, setModalState] = useState<IAddedToCartConfirmationModal | null>(null);

  return (
    <AddedToCartConfirmationModalContext.Provider
      value={{
        open: setModalState,
      }}
    >
      {modalState && (
        <AddedToCartConfirmationModalNoSSR
          {...modalState}
          onClose={() => {
            setModalState(null);
          }}
        />
      )}
      {children}
    </AddedToCartConfirmationModalContext.Provider>
  );
};

export default AddedToCartConfirmationModalProvider;
